import { render, staticRenderFns } from "./StatementsUnsererKunden.vue?vue&type=template&id=0e5c5914&scoped=true&"
import script from "./StatementsUnsererKunden.vue?vue&type=script&lang=js&"
export * from "./StatementsUnsererKunden.vue?vue&type=script&lang=js&"
import style0 from "./StatementsUnsererKunden.vue?vue&type=style&index=0&id=0e5c5914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c5914",
  null
  
)

export default component.exports